export default function InfoCards() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">深度实锤</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20warm%20dim%20lighting%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20surveillance%20photography%20aesthetic%2C%20empty%20hallway%20with%20soft%20amber%20glow%2C%20dramatic%20shadows%2C%20editorial%20cinematic%20composition&width=700&height=400&seq=cards-01&orientation=landscape"
                alt="顶流男星密会门完整时间线梳理"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-primary-100 text-primary-700 px-2 py-0.5 rounded whitespace-nowrap">深度调查</span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-2 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">顶流男星密会门完整时间线梳理</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">从第一次被拍到至今，半年内的所有关键节点一图看懂</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>25分钟阅读</span>
                <span><i className="ri-eye-line mr-1"></i>56万</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Financial%20documents%20and%20tax%20forms%20scattered%20on%20dark%20wooden%20desk%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20investigative%20journalism%20theme%2C%20dramatic%20shadows%2C%20moody%20atmosphere%2C%20editorial%20photography%20style&width=700&height=400&seq=cards-02&orientation=landscape"
                alt="知名女星税务问题全解析"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-accent-100 text-accent-800 px-2 py-0.5 rounded whitespace-nowrap">独家解析</span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-2 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">知名女星税务问题全解析</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">涉及金额、时间节点和可能的法律后果，一文说清楚</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>18分钟阅读</span>
                <span><i className="ri-eye-line mr-1"></i>89万</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20amber%20stage%20lighting%2C%20two%20empty%20chairs%20facing%20each%20other%2C%20reality%20show%20confrontation%20theme%2C%20cinematic%20wide%20shot%2C%20atmospheric%20fog%2C%20dramatic%20tension&width=700&height=400&seq=cards-03&orientation=landscape"
                alt="综艺录制事故背后的行业乱象"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-secondary-200 text-secondary-800 px-2 py-0.5 rounded whitespace-nowrap">事件追踪</span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-2 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">综艺录制事故背后的行业乱象</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">从嘉宾对骂到制作方暗箱操作，真人秀的真实生态</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>12分钟阅读</span>
                <span><i className="ri-eye-line mr-1"></i>112万</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20warm%20ring%20light%2C%20smartphone%20on%20tripod%2C%20fake%20follower%20count%20theme%2C%20dark%20background%20with%20glowing%20numbers%2C%20investigative%20tech%20expose%20style%2C%20dramatic%20contrast&width=700&height=400&seq=cards-04&orientation=landscape"
                alt="头部主播数据造假产业链深度调查"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-primary-100 text-primary-700 px-2 py-0.5 rounded whitespace-nowrap">深度调查</span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-2 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">头部主播数据造假产业链深度调查</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">从水军工厂到机器人刷量，揭秘数据造假的完整链条</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>22分钟阅读</span>
                <span><i className="ri-eye-line mr-1"></i>178万</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Film%20audition%20room%20with%20dramatic%20single%20spotlight%2C%20empty%20stage%20with%20director%20chair%20silhouette%2C%20casting%20call%20theme%2C%20mysterious%20dark%20atmosphere%2C%20warm%20amber%20light%20beam%2C%20cinematic%20backstage%20photography&width=700&height=400&seq=cards-05&orientation=landscape"
                alt="选角黑幕：那些被金钱换掉的主角"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-accent-100 text-accent-800 px-2 py-0.5 rounded whitespace-nowrap">独家揭秘</span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-2 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">选角黑幕：那些被金钱换掉的主角</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">多位业内人士匿名爆料，讲述选角过程中的灰色交易</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>15分钟阅读</span>
                <span><i className="ri-eye-line mr-1"></i>67万</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-background-300">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20lighting%2C%20empty%20microphone%20stand%20in%20spotlight%2C%20lip%20sync%20controversy%20theme%2C%20dark%20arena%20with%20warm%20red%20glow%2C%20professional%20audio%20equipment%20visible%2C%20cinematic%20wide%20composition&width=700&height=400&seq=cards-06&orientation=landscape"
                alt="演唱会假唱：从技术角度全面拆解"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-[10px] font-semibold bg-secondary-200 text-secondary-800 px-2 py-0.5 rounded whitespace-nowrap">技术分析</span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-2 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">演唱会假唱：从技术角度全面拆解</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">音频波形对比、现场录像分析，用数据告诉你真相</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>20分钟阅读</span>
                <span><i className="ri-eye-line mr-1"></i>143万</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}